export default __webpack_public_path__ + "static/media/3.56bf5040.jpg";